import * as Yup from 'yup';

export const schema = Yup.object().shape({
  FootbalopGameCardPostion: Yup.string().required('وارد کردن پست الزامی است'),
  FootbalopGameCardNation: Yup.string().required('وارد کردن ملیت الزامی است'),
  FootbalopGameCardName: Yup.string().required('وارد کردن نام کارت الزامی است'),
  FootbalopGameCardTeam: Yup.string().required('وارد کردن تیم الزامی است'),
  FootbalopGameCardSeason: Yup.string().required('وارد کردن فصل الزامی است'),
  FootbalopGameCardNumber: Yup.string().required('وارد کردن شماره کارت الزامی است'),
  FootbalopGameCardAttak: Yup.number().typeError('لطفا مقدار حمله را بصورت عددی وارد کنید').positive('مقدار باید یک عدد مثبت باشد'),
  FootbalopGameCardDefence: Yup.number().typeError('لطفا مقدار دفاع را بصورت عددی وارد کنید').positive('مقدار باید یک عدد مثبت باشد'),
  FootbalopGameCardSpeed: Yup.number().typeError('لطفا مقدار سرعت را بصورت عددی وارد کنید').positive('مقدار باید یک عدد مثبت باشد'),
  FootbalopGameCardOverall: Yup.number().typeError('لطفا مقدار امتیاز کلی را بصورت عددی وارد کنید').positive('مقدار باید یک عدد مثبت باشد'),
  FootbalopGameCardPrice: Yup.number().typeError('لطفا قیمت را بصورت عددی وارد کنید').positive('مقدار باید یک عدد مثبت باشد'),
  FootbalopGameCardStartKit: Yup.number().typeError('لطفا مقدار کیت شروع را بصورت عددی وارد کنید').positive('مقدار باید یک عدد مثبت باشد'),
  FootbalopGameCardVersion: Yup.number().typeError('لطفا ورژن کارت را بصورت عددی وارد کنید').positive('مقدار باید یک عدد مثبت باشد'),
});
